import { useEffect, useState } from 'react';

// Persists light/dark to localStorage; default dark (matches prototype).
export function ThemeToggle() {
  const [theme, setTheme] = useState(() => localStorage.getItem('hr-theme') || 'dark');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('hr-theme', theme);
  }, [theme]);

  return (
    <button
      className="mode-btn"
      aria-label="สลับโหมดสว่าง/มืด"
      onClick={() => setTheme((t) => (t === 'dark' ? 'light' : 'dark'))}
    >
      {theme === 'dark' ? '☾' : '☀'}
    </button>
  );
}
